import styled from "styled-components";
import ColapsideItemMaster from "./ColapsideItemMaster";



function Colapsider(props){

        return(
                <ColapsideContainer containerWidth={props.containerWidth}>
                {props.properties.map(i => (
                    <ColapsideItemMaster ItemId={i[0]} IconImage={i[1]} ColapsideItemTitle={i[2]} ColapsideItemContentDescrition={i[3]}/>)
                    )
                }           
                </ColapsideContainer>
                );

}

const ColapsideContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    padding: 0;
    width: ${props => props.containerWidth};
    transition: .3s ease-in-out;
    border-radius: 2px;
    box-shadow: 0px 1px 2px 2px rgba(0,0,0,0.2);

    @media (max-width: 1200px) {
    margin: 50px 0;
    width: 80vw;
    }
`

//How to Use:
//Pass the props when calling the Colapsider Component following the example bellow:
//
// <Colapside properties={
//                    [["01", OfferImage, "Planos de Acesso VIP Disponíveis",<PlanosAcessoVip/>],
//                     ["02", FactCheckImage, "Como Doar e Solicitar Acesso VIP",<ComoDoar/>]
//                    ] }/>
//
// OfferImage is a icon image (24x24)
//<ComoDoar /> is a jsx componente containing a spam or what you want to be inside of the content item, should be inside the folder "ColapsideItemDescription"


export default Colapsider;